import { datasource } from "./datasource";

export const customerProshopDS = (currentUserId, actions) => () =>
  datasource(currentUserId, actions)("customer_proshop", {
    model: {
      id: "id",
      auditable: true,
      syncable: true,
      byProshop: true,
      fields: {
        id: {
          type: "string",
        },
        proshop_id: {
          type: "string",
        },
        customer_id: {
          type: "string",
        },
        created_at: {
          type: "string",
        },
        updated_at: {
          type: "string",
        },
        created_by: {
          type: "string",
        },
        updated_by: {
          type: "string",
        },
      },
    },
  });
